import React from "react";
import T from "prop-types";
import { stringify } from "query-string";
import { Map } from "immutable";
import { connect } from "react-redux";
import { loadRecord } from "MODULES/shared/decorators";
import { RecordPager } from "MODULES/shared/components";
import { shortDate } from "LIB/formatters/date";
import * as actions from "MODULES/OutgoingShipments/actions";
import { API_BASE, CREATED_AT, ID } from "APP_ROOT/constants";
import Panel from "./Panel";
import Body from "./Body";
import Actions from "./Actions";
import Warnings from "./Warnings";

const DOWNLOAD_MAP = {
  SalesOrder: "sales_orders",
  ManagedRepairOrder: "managed_repair_orders",
  PurchaseOrder: "purchase_orders",
  RepairOrder: "repair_orders",
  ReturnedCore: "returned_cores",
  ReturnToCustomerRecord: "return_to_customer_records",
  Rma: "vendor_rmas"
};

export function Detail({ shipment }) {
  const id =
    shipment.get("reference_record_id") ||
    shipment.get("reference_record_line_item_id");

  const packingSlipUrl = `${API_BASE}/${DOWNLOAD_MAP[
    shipment.get("reference_record_type") ||
      shipment.get("reference_record_line_item_type")
  ]}/${id}/download_packing_slip?${stringify({
    shipment_id: shipment.get(ID)
  })}`;
  return (
    <div>
      <div className="page-header page-header-bar">
        <h1>
          <RecordPager baseUrl="/shipping" record={shipment} />
          &nbsp;{shipment.get("code")}&nbsp;
          <span className="small text-muted">
            Shipped {shortDate(shipment.get(CREATED_AT))}
          </span>
          <Actions url={packingSlipUrl} shipment={shipment} />
          <Warnings />
        </h1>
      </div>
      <div className="row">
        <Panel shipment={shipment.toJS()} />
        <Body shipment={shipment.toJS()} />
      </div>
    </div>
  );
}

Detail.propTypes = {
  shipment: T.instanceOf(Map).isRequired
};

export default connect(state => ({
  shipment: state.shipmentDetail.get("shipment")
}))(
  loadRecord({
    reducer: "shipmentDetail",
    name: "shipment",
    action: actions.fetch
  })(Detail)
);



// WEBPACK FOOTER //
// ./app/modules/OutgoingShipments/components/Detail/Detail.jsx